import { AppUser, PERMISSIONS } from "../../types/auth";

export const checkPermission = (
  permission: PERMISSIONS,
  user: AppUser | null,
): boolean => {
  if (!user) {
    return false;
  }

  // For other future permissions, treat based on the backend groups
  return !!(
    user?.backend?.is_admin || user?.backend?.groups?.includes(permission)
  );
};
